import clsx from 'clsx';
import style from './style.module.scss';

const Icon = ({ open, color, ...props }) => {
    return (
        <div
            className={clsx(style.menu, open && style.open, props.className)}
            style={{ color: color ?? style.primary500 }}
            {...props}
        >
            {Array.from(Array(3), (_, index) => (
                <span key={'menu_icon_' + index} />
            ))}
        </div>
    );
};

export default Icon;
